'use es6';

import { List, Record } from 'immutable';
import { AdExtensionTypes, AdWordsStatusMap, DaysOfWeek } from '../../lib/Constants'; //https://git.hubteam.com/HubSpot/Ads/blob/master/AdsData/src/main/java/com/hubspot/ads/data/adwords/extensions/FeedItemScheduleView.java

export const AdWordsFeedItemSchedule = Record({
  dayOfWeek: DaysOfWeek.SUNDAY,
  startTime: '00:00',
  endTime: '00:00'
}); // ExtensionFeedItemView.java, everything should inherit from this

const AdWordsAdExtensionFields = {
  status: AdWordsStatusMap.ENABLED,
  feedItemId: null,
  // this ad extension's id
  //extensionType: null,
  startTime: null,
  endTime: null,
  devicePreference: null,
  feedItemSchedules: List(),
  adGroupId: null,
  accountLevel: null,
  campaignId: null,
  description: '',
  accountId: null,

  getUniqueKey() {
    return this.feedItemId || Math.random();
  }

};
export const AdWordsCalloutAdExtensionRecord = Record(Object.assign({}, AdWordsAdExtensionFields, {
  extensionType: AdExtensionTypes.CALLOUT,
  text: null,

  getDescription() {
    return this.text;
  }

}));
export const AdWordsSiteLinkAdExtensionRecord = Record(Object.assign({}, AdWordsAdExtensionFields, {
  extensionType: AdExtensionTypes.SITELINK,
  text: null,
  line2: null,
  line3: null,
  finalUrl: null,
  finalMobileUrl: null,
  trackingTemplate: null,

  getDescription() {
    return this.text;
  }

}));